<template>
<div>
  <v-text-field :label="field.name" @click="onPickFile" v-model='fileName' prepend-icon="attach_file"></v-text-field>
  <input type="file" style="display: none" ref="fileInput" accept="*/*" @change="onFilePicked">
</div>
</template>

<script>
import {
  input
} from '@/mixins/input'
export default {
  mixins: [input],
  data() {
    return {
      fileName: ""
    }
  },
  computed: {
    locale: () => process.env.VUE_APP_LOCALE
  },
  mounted() {

  },
  created() {
    this.model = this.value
    if (this.model != undefined && this.model.length > 10) {
      this.fileName = this.$t("form.inputs.earlier")
    }
  },
  methods: {
    onPickFile() {
      this.$refs.fileInput.click()
    },
    onFilePicked(event) {
      const files = event.target.files
      if (files[0] !== undefined) {
        this.fileName = files[0].name
        if (this.fileName.lastIndexOf('.') <= 0) {
          return
        }

        const fr = new FileReader()
        fr.readAsDataURL(files[0])
        fr.addEventListener('load', () => {
          this.model = fr.result.split(';base64,')[1];
          this.fileName = files[0].name
        })

      } else {
        this.fileName = ''
        this.model = ""
      }
    }
  },
}
</script>

<style>

</style>
